<template>
    <v-container class="white" grid-list-xl fluid ma-0 pa-0>
      <v-col cols="12" md="12" sm="12" lg="12">
        <v-img
          :src="require('@/assets/vanampadi.jpg')"
          height="80%"
          width="50%"
        />
      </v-col>
      <v-row>
  
        <v-col cols="12" md="12" sm="12" lg="12">
          <v-card class="body-1 pa-0 elevation-0" style="max-width: 100%">
            <h2>Musical Event 2023</h2><br>
            <v-layout justify-center wrap>
              <v-flex xs12 md12>
                <v-card>
                  Join us on for a <b>Musical Night Live</b> brought to you by Vanambadi, a <b>CLTTS Tamil Orchestra.</b> 

                  <br><br>Get a chance to sing, play trivia and, win raffles!
                  <br><br>Come support our community band, We look forward to seeing you!
                  <br><br>Please use the below links to buy tickets:<br />
                <br>
                General Admission Adult (Age 18 and above) - $12 :
                  <a
                    href="https://my.cltts.org/#!/Vanambadi-2023-Adults-ticket/p/490878844/category=0"
                    target="_"
                    style="color: #8ebf42"
                    >Link</a
                  >
                  <br />
                  General Admission Kids (Age 5 to 18) - $8:
                  <a
                    href="https://my.cltts.org/#!/Vanambadi-2023-Kids-Age-5-18/p/450618383/category=0"
                    target="_"
                    style="color: #8ebf42"
                    >Link</a
                  >
                  <br />
                  Front-row seats - $25:
                  <a
                    href="https://my.cltts.org/#!/Vanambadi-2023-Special-Front-seat-tickets/p/538552649/category=0"
                    target="_"
                    style="color: #8ebf42"
                    >Link</a
                  >
                  <br />
                  <b><br>நன்றி.</b><br />
                  <b>சார்லட் தமிழ்ச் சங்கம்</b><br /><br /><br /><br /><br /><br />
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import ReportServices from "@/services/ReportServices";
  
  export default {
    name: "SectionBlogExcerptLeftImg",
    data() {
      return {
        allMemberData: [],
          search: '',
        loading: true,
        headers: [
          { text: "#", value: "s.no" },
          { text: "Member Name", value: "firstname" },
          { text: "Membership", value: "membershipcategory" }
        ],
        texts: [
          "நமது தமிழ் சங்கத்தின் புதியதொரு உதயம். பெருமிதத்துடன் ஒரு அத்தியாயம்.நமது இளைஞர் குழு.",
          "பலவகையான திறமைகளைத் தன்னுள் கொண்ட நமது இளைய தலைமுறை அவற்றை வெளிகொணரவும், தம்மைப்போல் ஆர்வமுள்ள பிற இளைஞர்களை சந்திக்கவும், தங்களது தமிழார்வத்தையும் கலாச்சார பற்றையும் வளர்த்துக் கொள்ளவும் வேண்டுமென்ற நோக்கத்தோடு இந்த குழு ஆரம்பிக்கப்பட்டது.",
          "தமது திறமையை வெளிக்காட்டும் ஒரு வடிகாலாக மட்டும் இல்லாமல் , சமுதாயத்துக்கு அவர்களால் ஆன உதவிகளை செய்யும் ஒரு களமாகவும் இந்த இளைஞர் அமைப்பு செயல்பட்டு வருகிறது.",
        ],
      };
    },
    computed: {
      filteredItems() {
        return this.allMemberData.filter((i) => {
          return i.membershipcategory === "Paarivallal" && i.year === "2023";
        });
      },
    },
    methods: {
      async refresh() {
        this.loading = true;
        this.allMemberData = (await ReportServices.index()).data;
        this.loading = false;
        this.noDataText = "No data available";
      },
    },
    async mounted() {
      this.refresh();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  #virtual-scroll-table {
    max-height: 400px;
    overflow: auto;
  }
  </style>
  